import { render } from "./CreateContent.vue?vue&type=template&id=be467714"
import script from "./CreateContent.vue?vue&type=script&lang=js"
export * from "./CreateContent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/cafemano-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__